module.exports = __webpack_public_path__ + "static/media/computer-bg.2e0ff9f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/computer-bg.png
// module id = 283
// module chunks = 0